"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = prepareSeparatorRegExp;
var separatorPattern = new RegExp('[.,]', 'g');

function prepareSeparatorRegExp(separators) {
  var fractionPart = separatorPattern;
  fractionPart.lastIndex = 0;

  if (separators) {
    separators = Array.isArray(separators) ? separators : [separators];
    fractionPart = separators.map(function (separator) {
      return typeof separator === 'string' && separator.length === 1 ? '\\' + separator : '';
    }).join('');
    fractionPart = new RegExp('[' + fractionPart + ']', 'g');
  }

  return fractionPart;
}

;